export default __webpack_public_path__ + "static/media/uri_logo.b98b05ef.png";